import { ActionIcon, Tooltip } from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useState } from "react";
import { downloadInvoice } from "../../../../../api/SubscriptionAPI";
import { useLanguage } from "../../../../../stores/LanguageStore";

const DownloadInvoice = ({ current }) => {
  const lang = useLanguage((s) => s.language);
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);

    downloadInvoice({ id: current.id, name: current.name }).finally(() =>
      setLoading(false)
    );
  };

  return (
    <Tooltip label={lang.settings.download_invoice}>
      <ActionIcon onClick={handleDownload} loading={loading} variant="subtle">
        <IconDownload />
      </ActionIcon>
    </Tooltip>
  );
};

export default DownloadInvoice;
